import React from 'react';
import { bool } from 'prop-types';
import { Card, Link, Typography } from '@one-thd/sui-atomic-components';
import { Orders } from '@one-thd/sui-icons';
import { RecentOrdersCardHeader } from '../subcomponents/cardHeader/RecentOrdersHeader';

function RecentOrdersFallbackCard({ isError, noData }) {
  let headerMessage;
  let subheaderMessage;
  let testIdType;

  if (isError) {
    testIdType = 'error';
    headerMessage = (
      <Typography>Hmm, we couldn&apos;t load your orders</Typography>
    );
    subheaderMessage = (
      <Typography>Try refreshing the page or check back later.</Typography>
    );
  } else if (noData) {
    testIdType = 'fallback';
    headerMessage = <Typography>No Recent Orders</Typography>;
    subheaderMessage = (
      <Typography>You haven&apos;t placed any orders recently</Typography>
    );
  }

  return (
    <Card data-testid={`recentOrders-card-${testIdType}`} className="sui-h-full sui-w-full" data-component="RecentOrdersFallbackCard">
      <RecentOrdersCardHeader />
      <div
        data-testid={`recentOrders-content-${testIdType}`}
        className="sui-flex sui-items-center sui-h-96 sui-w-full sui-flex-col sui-justify-center"
        data-type="container"
      >
        <Orders size="large" />
        <p className="sui-mt-8 sui-mb-4">{headerMessage}</p>
        <p className="sui-mb-8">{subheaderMessage}</p>
        <Link href="myaccount/purchase-history">View All Orders</Link>
      </div>
    </Card>
  );
}

RecentOrdersFallbackCard.propTypes = {
  isError: bool,
  noData: bool,
};

RecentOrdersFallbackCard.defaultProps = {
  isError: false,
  noData: false,
};

export { RecentOrdersFallbackCard };
